import { cloneElement, ReactNode } from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import { IonItem, IonLabel, IonList } from '@ionic/react';

export type InputType = 'date' | 'number' | 'tel' | 'text';

export type InputMode = 'tel' | 'text' | 'numeric';

export interface FieldInputProps {
    required?: boolean;
    readonly?: boolean;
}

export interface FieldProps {
    label?: string;
    stacked?: boolean;
    required?: boolean;
    readonly?: boolean;
    dataSet?: {[key: string]: string};
    children: ReactNode
}

export const Field: React.FC<FieldProps> = ({ label, stacked, required, readonly, dataSet = {}, children }) => {

    // build data attributes, e.g. dataSet={id:'test'} -> data-id="test"
    const dataAttributes = Object.keys(dataSet).reduce((map, k) => ({...map, [`data-${k}`]: dataSet[k]}), {});

    const labelPosition = (stacked || readonly ? 'stacked' : 'floating');
    const formattedLabel = `${label}${required && !readonly ? '*' : ''}`;
    const itemStyle = { '--padding-end': '20px' };
    const lines = readonly ? 'none' : undefined;

    // render children with some properties passed down from this Field wrapper
    const renderChildren = (_children: any) => {
        return flattenChildren(children).map((child: any) => {
            // don't attempt to copy props to html elements (type "<a>", "<div>", "<span>" etc) or we get a react warning
            const copyProps = typeof child.type !== 'string' ? { required, readonly, shape: 'round' } : {};
            return cloneElement(child, copyProps);
        });
    };

    return (
        <IonItem style={itemStyle} lines={lines} {...dataAttributes} >
            {label &&
                <IonLabel color="medium" position={labelPosition}>{formattedLabel}</IonLabel>
            }
            {renderChildren(children)}
        </IonItem>
    );
};

export const FieldList: React.FC<{children: ReactNode}> = ({ children }) => {
    return (
        <IonList>
            {children}
        </IonList>
    );
};
